import React, { useState, useEffect } from 'react';
import { Table, Space, Button, Card, Layout, Menu, Form, Input, Select, Switch  } from 'antd';
import {Await, Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import axios library
import { EditOutlined } from '@ant-design/icons';

import Sidebar from '../../Side_Bar/Admin_Side_Bar';
const { Option } = Select;

const View_Edit_Customer_Page = () => {
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getCustomerWithStatus`);
        // const response2 = await fetch(`${mainUrl}/getAllTable?tableName=User`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const customer_data = await response.json();

        // Adding 'index' property to each object in the array
        const dataWithIndex = customer_data.map((item, index) => ({
          ...item,
          index: index + 1, // Assuming you want to start the index from 1
        }));

        setCustomerData(dataWithIndex);
        setIsLoading(false);

      } catch (error) {
        console.error('Error fetching table data:', error);
        throw error;
      }
    };

    fetchData();

  }, [])

  const [form] = Form.useForm();

  // Columns for the table
  const columns = [
      //   {
      //     title: 'No.',
      //     dataIndex: 'index',
      //     key: 'index',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "customer_id"
      //             initialValue={text}
      //           >
      //             <Input disabled/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      {
        title: 'USERNAME',
        dataIndex: 'username',
        key: 'username',
        render: (text, record) => {
          return (
            <Form.Item
              name = "username"
              defaultValue={record.username}
            >
              <span>{text}</span>
            </Form.Item>
          );
        },
      },
      {
        title: 'PERSON IN CHARGE EMAIL',
        dataIndex: 'admin_email',
        key: 'admin_email',
        render: (text, record) => {
          return text;
        },
      },
      {
          title: 'COMPANY NAME',
          dataIndex: 'name',
          key: 'name',
          render: (text, record) => {
            return text;
          },
      },
      // {
      //     title: 'Company SSM No',
      //     dataIndex: 'ssm_no',
      //     key: 'ssm_no',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "ssm_no"   
      //             rules={[{ required: true, message: 'Please enter the SSM No' }]}
      //             initialValue={record.ssm_no}  
      //           >
      //             <Input/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Company Address',
      //     dataIndex: 'address',
      //     key: 'address',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "address"
      //             rules={[{ required: true, message: 'Please enter the address' }]}
      //           >
      //             <Input defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Company Description',
      //     dataIndex: 'business_description',
      //     key: 'business_description',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "business_description"
      //             rules={[{ required: true, message: 'Please enter the business description' }]}

      //           >
      //             <Input.TextArea defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Industry',
      //     dataIndex: 'industry',
      //     key: 'industry',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "industry"
      //             rules={[{ required: true, message: 'Please select the industry' }]}

      //           >
      //             <Select defaultValue={text}>
      //               <Option value="Retail">Retail</Option>
      //               <Option value="Construction">Construction</Option>
      //               <Option value="Transport">Transport</Option>
      //               <Option value="Agriculture">Agriculture</Option>
      //               <Option value="Manufacturing">Manufacturing</Option>
      //               <Option value="F&B">F&B</Option>
      //               <Option value="Pharmaceutical">Pharmaceutical</Option>
      //               <Option value="Other">Other</Option>
      //             </Select>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Person In Charge (PIC) Name',
      //     dataIndex: 'admin_name',
      //     key: 'admin_name',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "admin_name"
      //             rules={[{ required: true, message: 'Please enter the admin name' }]}

      //           >
      //             <Input defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Person In Charge (PIC) Contact Number',
      //     dataIndex: 'admin_contact_number',
      //     key: 'admin_contact_number',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "admin_contact_number"
      //             rules={[{ required: true, message: 'Please enter the PIC contact number' }]}
      //           >
      //             <Input defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Finance Email',
      //     dataIndex: 'finance_email',
      //     key: 'finance_email',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "finance_email"
      //             rules={[{ required: true, message: 'Please enter the finance email' }]}
      //           >
      //             <Input type="email" defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Notification Email',
      //     dataIndex: 'notification_email',
      //     key: 'notification_email',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "notification_email"
      //             rules={[{ required: true, message: 'Please enter the notification email' }]}
                
      //           >
      //             <Input type="email" defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Website URL',
      //     dataIndex: 'website_url',
      //     key: 'website_url',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "website_url"
      //             rules={[{ type: 'url', message: 'Please enter a valid URL' }]}

      //           >
      //             <Input type="url" defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Facebook Profile URL',
      //     dataIndex: 'facebook_profile_url',
      //     key: 'facebook_profile_url',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "facebook_profile_url"
      //             rules={[{ type: 'url', message: 'Please enter a valid URL' }]}

      //           >
      //             <Input type="url" defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      // {
      //     title: 'Instagram Profile URL',
      //     dataIndex: 'instagram_profile_url',
      //     key: 'instagram_profile_url',
      //     render: (text, record) => {
      //       if (editRow === record.index) {
      //         return (
      //           <Form.Item
      //             name = "instagram_profile_url"
      //             rules={[{ type: 'url', message: 'Please enter a valid URL' }]}

      //           >
      //             <Input type="url" defaultValue={text}/>
      //           </Form.Item>
      //         );
      //       }
      //       return text;
      //     },
      // },
      {
          title: 'USER STATUS',
          dataIndex: 'is_active',
          key: 'is_active',
          render: (text, record) => {
            return (
              <Form.Item 
              name={`is_active_${record.index}`} 
              valuePropName="checked"
              initialValue={(text === 1)? true:false}
              >
                <Switch 
                onChange={() => handleSwitchChange(record)} 
                />
              </Form.Item>
            );
          },
      },
  ];

  const handleSwitchChange = (record) => {
    const isEnabled = form.getFieldValue(`is_active_${record.index}`);

    const updatedData = {
      username: record.username,
      is_active: isEnabled
    };

    try{
      axios.put(mainUrl + `/updateUserStatus`, updatedData)
      .then(response => {
        console.log('Updated Company Cost:', response.data);
      })
      .catch(error => {
        console.error('Error updating company cost:', error.response ? error.response.data : error.message);
      });

    } catch (error) {
      console.error('Error updating customer:', error);
    } 

  };

  columns.push({
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    render: (_, record) => {  
      return (
        <>
          <Form.Item>
            <Button 
              onClick={() => handleEdit(record)} 
              style={{color: 'black'}}
              icon={<EditOutlined />}  // Replace EditOutlined with the correct import
            />
          </Form.Item>
        </>
      )
    },
  })

  const handleEdit = (record, row_index) => {
    form.setFieldsValue({
      customer_id: record.index,
      name: record.name,
      // ssm_no: record.ssm_no,
      // address: record.address,
      // business_description: record.business_description,
      // industry: record.industry,
      // admin_name: record.admin_name,
      // admin_contact_number: record.admin_contact_number,
      // admin_email: record.admin_email,
      // finance_email: record.finance_email,
      // notification_email: record.notification_email,
      // website_url: record.website_url,
      // facebook_profile_url: record.facebook_profile_url,
      // instagram_profile_url: record.instagram_profile_url,
      username: record.username,
      // ... (add other fields as needed)
    });
    navigate('/edit_customer', { state: { username: record.username } });
  };

  const onAddCustomerClick = () => {
    navigate('/add_customer');
  }

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '98vh' }}>
       <Sidebar location={location} />
       <Layout style={{ background: 'white'}}>
          <div 
          style={{ 
            maxWidth: '100%',
            maxHeight:"100%", 
            margin: '30px', 
            textAlign: 'center', 
            fontFamily: 'Helvetica, Arial, sans-serif' }}>
            <Card 
              title={<span style={{ fontSize: '20px', fontWeight: 'bold' }}>COMPANY INFORMATION</span>} 
              style={{ maxWidth: '100%', maxHeight: "100%" }}
            >
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  alignItems: 'center',
                  marginBottom: "1%"}}>
                    <Button
                      style={{ 
                        height: "50px", 
                        background: "#00308F",
                        color: "white" }}
                        onClick={()=>{onAddCustomerClick()}}
                      >
                      + Add Company
                    </Button>
              </div>

              <div style={{ overflowX: 'auto' }}>
                <Form form = {form}>
                  <Table 
                  dataSource={customerData} 
                  columns={columns}
                  scroll={{ x: 100, y: 800 }}
                    />
                </Form>
              </div>
            </Card>
          </div>
        </Layout>
      </Layout>
  );
};

export default View_Edit_Customer_Page;